import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Snackbar } from "@mui/material/";
import actions from "../../Store/actions";

const AUTO_HIDE_DURATION = 4e3;

/**
 * Toaster Component
 */
const Toaster = () => {
    const dispatch = useDispatch();
    const { toast } = useSelector((state) => state);
    const [activeToast, setActiveToast] = React.useState({});
    const [open, setOpen] = React.useState(false);
    const queue = React.useRef([]);

    const onClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        dispatch(actions.toast.create.remove());
        setOpen(false);
    };

    const processQueue = () => {
        if (queue.current.length > 0) {
            setActiveToast(queue.current.shift());
            setOpen(true);
        }
    };

    React.useEffect(() => {
        // toast.length > 0 && queue.current.push(toast[0]);
        /**As requested the toast will have the last message*/
        if (toast.length === 1) {
            setActiveToast(toast[0]);
            setOpen(true);
        } else if (toast.length > 1) {
            dispatch(actions.toast.create.remove());
            setActiveToast(toast[toast.length - 1]);
            setOpen(true);
        }
        //processQueue();
    }, [toast]);

    return (
        <Snackbar
            anchorOrigin={{ horizontal: "center", vertical: "top" }}
            autoHideDuration={AUTO_HIDE_DURATION}
            onClose={onClose}
            open={open}
        >
            <Alert onClose={onClose} severity={activeToast.variant}>
                {activeToast.message}
            </Alert>
        </Snackbar>
    );
};

export default Toaster;
